import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { useECSettingsContext } from '../../contexts/ecSettings';
import Navmenu from '../navmenu';
import ProviderCarousel from './ProviderCarousel';
import ProductCarousel from './ProductCarousel';
import ProviderProductCarousel from './ProviderProductCarousel';
import IMG from '../img';

const Banner = styled(IMG)`
  width: 100%;
  margin-left: 0;
  object-fit: contain;
  display: block;
  @media (max-width: 1340px) {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }
`;

const ComponentContainer = styled.div`
  min-height: 100vh;
`;

export default () => {
  const { ecSettings } = useECSettingsContext();
  const homepageSettings = useMemo(() => _.get(ecSettings, ['HOMEPAGE'], []), [ecSettings]);

  const renderHomepageBanner = useCallback(
    (params) => (params.data || []).map((url) => <Banner key={url} src={url} />),
    []
  );

  const renderHomepageProviderCarousel = useCallback(
    (params) => <ProviderCarousel name={params.name} providers={params.data} key={params.name} />,
    []
  );

  const renderHomdpageProductCarousel = useCallback(
    (params) => <ProductCarousel name={params.name} products={params.data} key={params.name} />,
    []
  );

  const renderHomepageProviderProductCarousel = useCallback(
    (params) => (
      <ProviderProductCarousel
        name={params.name}
        provider={params.provider}
        products={params.data}
        key={params.name}
      />
    ),
    []
  );

  return (
    <>
      <Navmenu />
      <ComponentContainer>
        {
          (homepageSettings || []).map((page) => {
            try {
              const {
                type,
                ...other
              } = page;
              switch (type) {
                case 'BANNER':
                  return renderHomepageBanner(other);
                case 'PROVIDER_CAROUSEL':
                  return renderHomepageProviderCarousel(other);
                case 'PRODUCT_CAROUSEL':
                  return renderHomdpageProductCarousel(other);
                case 'PROVIDER_PRODUCT_CAROUSEL':
                  return renderHomepageProviderProductCarousel(other);
                default: return null;
              }
            } catch (error) {
              console.error(error);
            }
            return null;
          })
        }
      </ComponentContainer>
    </>
  );
};
